import universal from "./universal.component";
import universalUrls from "./universal.urls";
import UniversalTransforms from "./universal.transforms";

const universalModule = angular
  .module("app.components.universal", [])
  .component("universalPage", universal)
  .service("UniversalTransforms", UniversalTransforms)
  .config(universalUrls);

export default universalModule;



// WEBPACK FOOTER //
// ./src/pages/universal/universal.module.js